import React from 'react';
import styles from './Table.module.css';
import { classNames } from '../../utils/helpers';
import Skeleton from '../Skeleton';

function Table({ children, className, ...props }) {
  return (
    <div className={styles.wrapper}>
      <table className={classNames(styles.table, className)} {...props}>
        {children}
      </table>
    </div>
  );
}

function TableHead({ children }) {
  return <thead className={styles.thead}>{children}</thead>;
}

function TableBody({ children }) {
  return <tbody className={styles.tbody}>{children}</tbody>;
}

function TableRow({ children, onClick, clickable = false }) {
  return (
    <tr
      className={classNames(styles.row, clickable && styles.clickable)}
      onClick={onClick}
    >
      {children}
    </tr>
  );
}

function TableHeader({ children, align = 'left', className, ...props }) {
  return (
    <th className={classNames(styles.th, styles[`align-${align}`], className)} {...props}>
      {children}
    </th>
  );
}

function TableCell({ children, align = 'left', className, ...props }) {
  return (
    <td className={classNames(styles.td, styles[`align-${align}`], className)} {...props}>
      {children}
    </td>
  );
}

function TableSkeleton({ rows = 5, columns = 4 }) {
  return (
    <Table>
      <TableHead>
        <TableRow>
          {Array.from({ length: columns }).map((_, i) => (
            <TableHeader key={i}>
              <Skeleton variant="rectangular" height={14} width="80%" />
            </TableHeader>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <TableRow key={rowIndex}>
            {Array.from({ length: columns }).map((_, colIndex) => (
              <TableCell key={colIndex}>
                <Skeleton variant="rectangular" height={14} width={colIndex === 0 ? '60%' : '100%'} />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

Table.Head = TableHead;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Header = TableHeader;
Table.Cell = TableCell;
Table.Skeleton = TableSkeleton;

export default Table;
